/* eslint-disable no-prototype-builtins */
/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import {
  Paper,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Autocomplete,
  Grid,
} from "@mui/material";
import TextFieldMUI from "@mui/material/TextField";
import e from "express";
import { BeatLoader } from "react-spinners";
import { RootStateOrAny, useSelector } from "react-redux";
import * as SVGIcons from "../../../../../../assets/iconsSVG";
import UserPlus from "../../../../../../assets/images/userplus.png";
import { useCorretoresEmpresaVendas } from "../../../../../../services/api";
import * as Styles from "./styles";
import { useListarTiposAtendimentos } from "../../../../../../services/api/AppWeb_TipoAtendimento";
import { useEditarAtendimento } from "../../../../../../services/api/AppWeb_Atendimento/editar-atendimento";
import warn from "../../../../../../constants/toast";
import { AuthState } from "../../../../../../store/ducks/auth/types";
import { converterObjetoParaString } from "../../../../../../hooks/convertObjectToString";

interface DataProps {
  dataHoraAlteracao: string | null;
  dataHoraVisita: string | null;
  idAtendimento: string | null;
  idCorretor: string | null;
  idEmpreendimento: string | null;
  idLead: string | null;
  idTarefaLead: string | null;
  idTipoAtendimento: string | null;
  motivoAlteracao: string | null;
  nomeCorretor: string | null;
  nomeLead: string | null;
  registradoPor: string | null;
  tipoAtendimento: string | null;
}

interface Props {
  closeModal: any;
  data: DataProps;
  refresh: () => void;
}

const CustomPaper = (props: any) => {
  return <Paper sx={{ marginTop: 2 }} {...props} />;
};

const FormNovoAtendimento = (props: Props) => {
  const { empresaVendas } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const { data: dataCorretoresEmpresasVendasResponse } =
    useCorretoresEmpresaVendas({
      queryKey: `corretores_empresas_header`,
      params: converterObjetoParaString({
        idsEmpresasVendas: empresaVendas?.map((item: any) => item.id),
      }),
      enabled: true,
    });
  const [corretorOrigemList, setCorretorOrigemList]: any = useState([]);
  const [corretorOrigemValue, setCorretorOrigemValue] = useState<any>(null);
  const [tiposAtendimentosList, setTiposAtendimentosList]: any = useState([]);
  const [tiposAtendimentosValue, setTiposAtendimentosValue] =
    useState<any>(null);
  const { data: dataTiposAtendimentosValueResponse } =
    useListarTiposAtendimentos();
  const [motivoAlteracao, setMotivoAlteracao] = useState("");
  const MAX_CHARACTERS = 300;
  const remainingCharacters = MAX_CHARACTERS - motivoAlteracao.length;

  useEffect(() => {
    getCorretorOrigem();
  }, [dataCorretoresEmpresasVendasResponse]);

  const getCorretorOrigem = () => {
    const formattedData: any = [];
    dataCorretoresEmpresasVendasResponse?.data.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.idCorretor,
      })
    );
    setCorretorOrigemList(formattedData);
  };

  useEffect(() => {
    getTiposAtendimentos();
  }, [dataTiposAtendimentosValueResponse]);

  const getTiposAtendimentos = () => {
    const formattedData: any = [];
    dataTiposAtendimentosValueResponse?.data.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.id,
      })
    );
    setTiposAtendimentosList(formattedData);
  };

  useEffect(() => {
    console.log({
      label: props?.data?.tipoAtendimento,
      value: props?.data?.idTipoAtendimento,
    });
    if (props.data) {
      if (
        props?.data?.nomeCorretor === null ||
        props?.data?.idCorretor === null
      ) {
        setTiposAtendimentosValue(null);
      } else {
        setCorretorOrigemValue({
          label: props.data?.nomeCorretor,
          value: props.data?.idCorretor,
        });
      }
      if (
        props?.data?.tipoAtendimento === null ||
        props?.data?.idTipoAtendimento === null
      ) {
        setTiposAtendimentosValue(null);
      } else {
        setTiposAtendimentosValue({
          label: props?.data?.tipoAtendimento,
          value: props?.data?.idTipoAtendimento,
        });
      }
    }
  }, [props.data]);

  const handleMutate = () => {
    mutate();
  };

  const {
    mutate,
    isSuccess,
    data: dataResp,
    isLoading: isLoadingEdicao,
  } = useEditarAtendimento({
    idAtendimento: props?.data?.idAtendimento,
    idCorretor: corretorOrigemValue?.value,
    nomeCorretor: corretorOrigemValue?.label,
    idTipoVisita: tiposAtendimentosValue?.value,
    descricaoTipoVisita: tiposAtendimentosValue?.label,
    motivoAlteracao,
  });

  useEffect(() => {
    if (isSuccess) {
      warn.wargingSuccess(dataResp?.data?.data);
      props.closeModal();
      props.refresh();
    }
  }, [isSuccess, dataResp]);

  return (
    <Styles.Container>
      <Styles.RowSpace>
        <SVGIcons.EditUserIcon />
        <IconButton onClick={() => props.closeModal()}>
          <IoMdClose size={22} />
        </IconButton>
      </Styles.RowSpace>
      <Styles.Space space={16} />
      <Styles.StrongText>Editar atendimento</Styles.StrongText>
      <Styles.Space space={16} />
      <Styles.LightText>
        Você pode alterar o corretor de{" "}
        <Styles.LightTextGreen>atendimento</Styles.LightTextGreen> e o tipo de
        visita.
      </Styles.LightText>
      <Styles.Space space={16} />
      <Styles.InputLable>Corretor *</Styles.InputLable>
      <Autocomplete
        id="combo-box-demo"
        options={corretorOrigemList}
        value={corretorOrigemValue}
        onChange={(event: any, value: any) => {
          setCorretorOrigemValue(value);
        }}
        autoHighlight
        size="small"
        fullWidth
        PaperComponent={CustomPaper}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              "& .MuiAutocomplete-inputRoot": {
                paddingLeft: "8px !important",
                borderRadius: "8px",
                height: "40px",
              },
            }}
            placeholder=""
          />
        )}
      />
      <Styles.Space space={16} />
      <Styles.InputLable>Tipo de visita *</Styles.InputLable>
      <Autocomplete
        componentsProps={{
          paper: {
            sx: {
              borderRadius: "4px",
            },
          },
        }}
        options={tiposAtendimentosList}
        value={tiposAtendimentosValue}
        onChange={(event: any, value: any) => {
          setTiposAtendimentosValue(value);
        }}
        autoHighlight
        size="small"
        fullWidth
        PaperComponent={CustomPaper}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              "& .MuiAutocomplete-inputRoot": {
                paddingLeft: "8px !important",
                borderRadius: "8px",
                height: "40px",
              },
            }}
            placeholder=""
          />
        )}
      />
      <Styles.Space space={16} />
      <Styles.InputLable>Motivo da alteração *</Styles.InputLable>
      <TextFieldMUI
        value={motivoAlteracao}
        onChange={(event: any) => setMotivoAlteracao(event.target.value)}
        size="small"
        variant="outlined"
        label=""
        placeholder=""
        fullWidth
        multiline
        maxRows={4}
        InputProps={{
          style: {
            borderRadius: 8,
          },
        }}
      />
      <Styles.Space space={32} />
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <Button
            onClick={() => props.closeModal()}
            style={{
              color: "#333333",
              borderColor: "#A3A3A6",
              backgroundColor: "#ffffff",
              textTransform: "none",
            }}
            variant="outlined"
            fullWidth
          >
            Cancelar
          </Button>
        </Grid>
        <Grid item md={6} xs={12}>
          <Button
            onClick={() => handleMutate()}
            style={{
              backgroundColor: "#2D5BFF",
              color: "#fff",
              textTransform: "none",
              minHeight: "35px",
            }}
            variant="contained"
            fullWidth
          >
            {isLoadingEdicao ? <BeatLoader color="#fff" size={10} /> : "Salvar"}
          </Button>
        </Grid>
      </Grid>
    </Styles.Container>
  );
};

export default FormNovoAtendimento;
